module.exports = __webpack_public_path__ + "static/media/01F.56b814fa.png";